import React from 'react';
import { HiddenInput } from 'components/reusable/HiddenInput';

function UpdateMethodInput() {
  return (<HiddenInput name="_method" value="patch" />);
}

export default UpdateMethodInput;
